import { IUploadRequestParams, IAssetUrlDTO, IContactUploadRequestParams } from './shared.dto';

type EventUploadPathKey = 'passport' | 'attendee' | 'meeting' | 'scheduled-emails' | 'email-configuration' | 'eventHub' | 'event';
type AccountUploadPathKey = 'account-contact';
type ContactUploadPathKey = 'rolodex-contact';
type UploadPathKey = EventUploadPathKey | AccountUploadPathKey | ContactUploadPathKey;
type UploadRequestParams = IUploadRequestParams | IContactUploadRequestParams;

abstract class IFileToS3DAO {
    public abstract getS3AssetUrl(params: UploadRequestParams, path: string): Promise<IAssetUrlDTO>;
    public abstract uploadFileToS3(file: File, params: UploadRequestParams, pathKey: UploadPathKey): Promise<IAssetUrlDTO>;
    public abstract uploadImageToS3(image: File, params: IUploadRequestParams, pathKey: UploadPathKey): Promise<IAssetUrlDTO>;
}

export {
    IFileToS3DAO,
    EventUploadPathKey,
    AccountUploadPathKey,
    ContactUploadPathKey,
    UploadPathKey,
    UploadRequestParams
};
